/* eslint-disable react/no-unescaped-entities */
import Footer from '@components/Footer/Footer';
import Header from '@components/Header/Header';
import { analytics } from '@database/firebase';
import { logEvent } from '@firebase/analytics';
import colors from '@styles/common/colors';
import typography from '@styles/common/typography';
import React, { useEffect } from 'react';
import styled from 'styled-components';

const Privacy: React.FC = () => {
  useEffect(() => {
    logEvent(analytics, 'Privacy');
  }, []);

  return (
    <>
      <Header />
      <PrivacyLayout>
        <Title>Policy Privacy</Title>
        <UpdateText>Last updated: February 27, 2024</UpdateText>
        <Content>Website address: https://lapagodekhmere.com</Content>
        <Content>Owner: La Pagode Khmère</Content>
        <Content>Headquarters: 46, rue Branly, 94110, ARCUEIL, FRANCE</Content>
        <Content>SIRET Number: 94980059300012</Content>
        <Content>Publication Manager: Puthpiseth TUN - contact@tun-puthpiseth.com</Content>
        <Content>Hosting: Firebase</Content>
        <Content>Photo Credits: Danille Guéret et Dominique-Pierre Guéret</Content>
        <SectionLayout>
          <Content>
            This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your
            information when You use the Service and tells You about Your privacy rights and how the law protects You.
          </Content>
          <Content>
            We use Your Personal data to provide and improve the Service. By using the Service, You agree to the
            collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been
            created with the help of the{' '}
            <Links href="https://www.termsfeed.com/privacy-policy-generator/" target="_blank" rel="noreferrer">
              Privacy Policy Generator
            </Links>
            .
          </Content>
          <SubTitle>Interpretation and Definitions</SubTitle>
          <Content>
            <strong>Interpretation</strong>
          </Content>
          <Content>
            The words of which the initial letter is capitalized have meanings defined under the following conditions.
            The following definitions shall have the same meaning regardless of whether they appear in singular or in
            plural.
          </Content>
          <Content>
            <strong>Definitions</strong>
          </Content>
          <Content>For the purposes of this Privacy Policy:</Content>
          <List>
            <strong>Account</strong> means a unique account created for You to access our Service or parts of our
            Service.
          </List>
          <List>
            <strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a
            party, where "control" means ownership of 50% or more of the shares, equity interest or other securities
            entitled to vote for election of directors or other managing authority.
          </List>
          <List>
            <strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers
            to La Pagode Khmère.
          </List>
          <List>
            <strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device
            by a website, containing the details of Your browsing history on that website among its many uses.
          </List>
          <List>
            <strong>Country</strong> refers to: France
          </List>
          <List>
            <strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a
            digital tablet.
          </List>
          <List>
            <strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.
          </List>
          <List>
            <strong>Service</strong> refers to the Website.
          </List>
          <List>
            <strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the
            Company. It refers to third-party companies or individuals employed by the Company to facilitate the
            Service, to provide the Service on behalf of the Company, to perform services related to the Service or to
            assist the Company in analyzing how the Service is used.
          </List>
          <List>
            <strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the
            Service or from the Service infrastructure itself (for example, the duration of a page visit).
          </List>
          <List>
            <strong>Website</strong> refers to La Pagode Khmère, accessible from{' '}
            <Links href="https://lapagodekhmere.com" rel="external nofollow noopener" target="_blank">
              https://lapagodekhmere.com
            </Links>
          </List>
          <List>
            <strong>You</strong> means the individual accessing or using the Service, or the company, or other legal
            entity on behalf of which such individual is accessing or using the Service, as applicable.
          </List>
        </SectionLayout>
        {/* <SubTitle>Propriétaire intéllectuelle</SubTitle>
        <Content>
          Tous les éléments de l'application mobile et du site web (textes, images, vidéos, etc.) sont protégés par les
          lois françaises et internationales sur la propriété intellectuelle et plus particulièrement le droit d'auteur.
        </Content>
        <Content>
          Les informations figurant sur le site sont uniquement disponibles à des fins de consultation par les
          utilisateurs, à défaut d'un accord préalable et exprès.
        </Content>
        <Content>
          Toute reproduction, représentation, modification, publication, transmission, totale ou partielle de
          l'application mobile et du site web, sans l'autorisation préalable écrite de l'entreprise individuelle est
          strictement interdite et engage la responsabilité de l'utilisateur.
        </Content> */}
        <SubTitle>Collecting and Using Your Personal Data</SubTitle>
        <SubSmallTitle>Types of Data Collected</SubSmallTitle>
        <Content>
          <u>Personal Data</u>
        </Content>
        <Content>
          While using Our Service, We may ask You to provide Us with certain personally identifiable information that
          can be used to contact or identify You. Personally identifiable information may include, but is not limited
          to:
        </Content>
        <List>Email address</List>
        <List>First name and last name</List>
        <List>Usage Data</List>
        <Content>
          <u>Usage Data</u>
        </Content>
        <Content>Usage Data is collected automatically when using the Service.</Content>
        <Content>
          Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser
          type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time
          spent on those pages, unique device identifiers and other diagnostic data.
        </Content>
        <Content>
          When You access the Service by or through a mobile device, We may collect certain information automatically,
          including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address
          of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique
          device identifiers and other diagnostic data.
        </Content>
        <Content>
          We may also collect information that Your browser sends whenever You visit our Service or when You access the
          Service by or through a mobile device.
        </Content>
        <Content>
          <u>Tracking Technologies and Cookies</u>
        </Content>
        <Content>
          We use Cookies and similar tracking technologies to track the activity on Our Service and store certain
          information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to
          improve and analyze Our Service. The technologies We use may include:
        </Content>
        <List>
          <strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device. You can instruct
          Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept
          Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting
          so that it will refuse Cookies, our Service may use Cookies.
        </List>
        <List>
          <strong>Web Beacons.</strong> Certain sections of our Service and our emails may contain small electronic
          files known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel gifs) that permit the
          Company, for example, to count users who have visited those pages or opened an email and for other related
          website statistics (for example, recording the popularity of a certain section and verifying system and server
          integrity).
        </List>
        <Content>
          Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on Your personal computer or
          mobile device when You go offline, while Session Cookies are deleted as soon as You close Your web browser.
          You can learn more about cookies on{' '}
          <Links href="https://www.termsfeed.com/blog/cookies/#What_Are_Cookies" target="_blank">
            TermsFeed website
          </Links>{' '}
          article.
        </Content>
        <Content>We use both Session and Persistent Cookies for the purposes set out below:</Content>
        <List>
          <strong>Necessary / Essential Cookies</strong>
        </List>
        <Content>Type: Session Cookies</Content>
        <Content>Administered by: Us</Content>
        <Content>
          Purpose: These Cookies are essential to provide You with services available through the Website and to enable
          You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts.
          Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies
          to provide You with those services.
        </Content>
        <List>
          <strong>Cookies Policy / Notice Acceptance Cookies</strong>
        </List>
        <Content>Type: Persistent Cookies</Content>
        <Content>Administered by: Us</Content>
        <Content>Purpose: These Cookies identify if users have accepted the use of cookies on the Website.</Content>
        <List>
          <strong>Functionality Cookies</strong>
        </List>
        <Content>Type: Persistent Cookies</Content>
        <Content>Administered by: Us</Content>
        <Content>
          Purpose: These Cookies allow us to remember choices You make when You use the Website, such as remembering
          your login details or language preference. The purpose of these Cookies is to provide You with a more personal
          experience and to avoid You having to re-enter your preferences every time You use the Website.
        </Content>
        <Content>
          For more information about the cookies we use and your choices regarding cookies, please visit our Cookies
          Policy or the Cookies section of our Privacy Policy.
        </Content>

        <Content>
          <u>Use of Your Personal Data</u>
        </Content>
        <Content>The Company may use Personal Data for the following purposes:</Content>
        <List>
          <strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.
        </List>
        <List>
          <strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The Personal
          Data You provide can give You access to different functionalities of the Service that are available to You as
          a registered user.
        </List>
        <List>
          <strong>For the performance of a contract:</strong> the development, compliance and undertaking of the
          purchase contract for the products, items or services You have purchased or of any other contract with Us
          through the Service.
        </List>
        <List>
          <strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of
          electronic communication, such as a mobile application's push notifications regarding updates or informative
          communications related to the functionalities, products or contracted services, including the security
          updates, when necessary or reasonable for their implementation.
        </List>
        <List>
          <strong>To provide You</strong> with news, special offers and general information about other goods, services
          and events which we offer that are similar to those that you have already purchased or enquired about unless
          You have opted not to receive such information.
        </List>
        <List>
          <strong>To manage Your requests:</strong> To attend and manage Your requests to Us.
        </List>
        <List>
          <strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger,
          divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our
          assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which
          Personal Data held by Us about our Service users is among the assets transferred.
        </List>
        <List>
          <strong>For other purposes</strong>: We may use Your information for other purposes, such as data analysis,
          identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and
          improve our Service, products, services, marketing and your experience.
        </List>
        <Content>We may share Your personal information in the following situations:</Content>
        <List>
          <strong>With Service Providers:</strong> We may share Your personal information with Service Providers to
          monitor and analyze the use of our Service, to contact You.
        </List>
        <List>
          <strong>For business transfers:</strong> We may share or transfer Your personal information in connection
          with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a
          portion of Our business to another company.
        </List>
        <List>
          <strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will
          require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other
          subsidiaries, joint venture partners or other companies that We control or that are under common control with
          Us.
        </List>
        <List>
          <strong>With business partners:</strong> We may share Your information with Our business partners to offer You
          certain products, services or promotions.
        </List>
        <List>
          <strong>With other users:</strong> when You share personal information or otherwise interact in the public
          areas with other users, such information may be viewed by all users and may be publicly distributed outside.
        </List>
        <List>
          <strong>With Your consent</strong>: We may disclose Your personal information for any other purpose with Your
          consent.
        </List>
        <Content>
          <u>Retention of Your Personal Data</u>
        </Content>
        <Content>
          The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this
          Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal
          obligations (for example, if we are required to retain your data to comply with applicable laws), resolve
          disputes, and enforce our legal agreements and policies.
        </Content>
        <Content>
          The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a
          shorter period of time, except when this data is used to strengthen the security or to improve the
          functionality of Our Service, or We are legally obligated to retain this data for longer time periods.
        </Content>
        <Content>
          <u>Transfer of Your Personal Data</u>
        </Content>
        <Content>
          Your information, including Personal Data, is processed at the Company's operating offices and in any other
          places where the parties involved in the processing are located. It means that this information may be
          transferred to — and maintained on — computers located outside of Your state, province, country or other
          governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.
        </Content>
        <Content>
          Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement
          to that transfer.
        </Content>
        <Content>
          The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in
          accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization
          or a country unless there are adequate controls in place including the security of Your data and other
          personal information.
        </Content>
        <Content>
          <u>Delete Your Personal Data</u>
        </Content>
        <Content>
          You have the right to delete or request that We assist in deleting the Personal Data that We have collected
          about You.
        </Content>
        <Content>
          Our Service may give You the ability to delete certain information about You from within the Service.
        </Content>
        <Content>
          You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one,
          and visiting the account settings section that allows you to manage Your personal information. You may also
          contact Us to request access to, correct, or delete any personal information that You have provided to Us.
        </Content>
        <Content>
          Please note, however, that We may need to retain certain information when we have a legal obligation or lawful
          basis to do so.
        </Content>
        <Content>
          <u>Disclosure of Your Personal Data</u>
        </Content>
        <Content>
          <u>Business Transactions</u>
        </Content>
        <Content>
          If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We
          will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy
          Policy.
        </Content>
        <Content>
          <u>Law enforcement</u>
        </Content>
        <Content>
          Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so
          by law or in response to valid requests by public authorities (e.g. a court or a government agency).
        </Content>
        <Content>
          <u>Other legal requirements</u>
        </Content>
        <Content>
          The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
        </Content>
        <List>Comply with a legal obligation</List>
        <List>Protect and defend the rights or property of the Company</List>
        <List>Prevent or investigate possible wrongdoing in connection with the Service</List>
        <List>Protect the personal safety of Users of the Service or the public</List>
        <List>Protect against legal liability</List>
        <Content>
          <u>Security of Your Personal Data</u>
        </Content>
        <Content>
          The security of Your Personal Data is important to Us, but remember that no method of transmission over the
          Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means
          to protect Your Personal Data, We cannot guarantee its absolute security.
        </Content>
        <SubSmallTitle>Children's Privacy</SubSmallTitle>
        <Content>
          Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable
          information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child
          has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data
          from anyone under the age of 13 without verification of parental consent, We take steps to remove that
          information from Our servers.
        </Content>
        <Content>
          If We need to rely on consent as a legal basis for processing Your information and Your country requires
          consent from a parent, We may require Your parent's consent before We collect and use that information.
        </Content>
        <SubSmallTitle>Links to Other Websites</SubSmallTitle>
        <Content>
          Our Service may contain links to other websites that are not operated by Us. If You click on a third party
          link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of
          every site You visit.
        </Content>
        <Content>
          We have no control over and assume no responsibility for the content, privacy policies or practices of any
          third party sites or services.
        </Content>
        <SubSmallTitle>Changes to this Privacy Policy</SubSmallTitle>
        <Content>
          We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new
          Privacy Policy on this page.
        </Content>
        <Content>
          We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming
          effective and update the "Last updated" date at the top of this Privacy Policy.
        </Content>
        <Content>
          You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are
          effective when they are posted on this page.
        </Content>

        <SubTitle>Payment via a third party</SubTitle>
        <Content>
          When you make a payment on our website, we may collect certain information necessary to process the
          transaction, such as your name, billing address, email address, and payment details. Please note that we do
          not store your credit card details or bank account information. The payment information you provide is
          directly processed by our third-party payment service provider, such as Stripe, in accordance with their own
          privacy policies and terms of use.
        </Content>

        <SubTitle>Contact Us</SubTitle>
        <Content>If you have any questions about this Privacy Policy, You can contact us:</Content>
        <List>By email: contact@tun-puthpiseth.com</List>
      </PrivacyLayout>
      <Footer />
    </>
  );
};

export default Privacy;

const SectionLayout = styled.div`
  margin: 12px 0;
`;

const Links = styled.a`
  color: ${colors.dark_tangerine};
`;

const UpdateText = styled.div`
  text-align: center;
  font-size: ${typography.fontSize.md};
  color: ${colors.text_grey};
  letter-spacing: 0.5px;
  margin-bottom: 32px;
`;

const PrivacyLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 100px 15px;

  @media (min-width: 320px) {
    padding: 100px 42px;
  }
  @media (min-width: 768px) {
    padding: 100px 15px;
  }
  @media (min-width: 1024px) {
    padding: 100px 53px;
  }
  @media (min-width: 1280px) {
    padding: 100px 180px;
  }
  @media (min-width: 1440px) {
    padding: 100px 380px;
  }
  @media (min-width: 1920px) {
    padding: 100px 590px;
  }
`;

const Title = styled.div`
  font-size: ${typography.fontSize['3xl']};
  font-weight: bold;
  color: ${colors.dark_tangerine};
  letter-spacing: 1px;
  text-align: center;
  margin-bottom: 16px;

  @media (min-width: 1280px) {
    font-size: ${typography.fontSize['4xl']};
  }
`;

const SubTitle = styled.div`
  font-size: 22px;
  font-weight: bold;
  color: ${colors.text_grey};
  letter-spacing: 0.5px;
  margin: 8px 0;
`;

const SubSmallTitle = styled.div`
  font-size: 20px;
  font-weight: medium;
  color: ${colors.text_grey};
  letter-spacing: 0.5px;
  text-decoration: underline;
`;

const Content = styled.div`
  font-size: ${typography.fontSize.md};
  color: ${colors.text_grey};
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-bottom: 12px;

  @media (min-width: 1024px) {
    font-size: ${typography.fontSize.lg};
    line-height: 26px;
  }
  @media (min-width: 1440px) {
    font-size: ${typography.fontSize.xl};
    line-height: 30px;
  }
`;

const List = styled.li`
  font-size: 16px;
  color: ${colors.text_grey};
  letter-spacing: 0.5px;
  line-height: 28px;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;
